import toast from "react-hot-toast";
import loanStore from "mobx/LoanStore";

import { BASE_URL } from "services";
import http from "./httpService";
import apiRoute from "routes/apirRoutes";
import { AxiosError } from "axios";

export async function loanChart() {
  try {
    const { data } = await http.get(`${BASE_URL}/analytics/loans/chart`);
    return data;
  } catch (err) {
    return null;
  }
}

export async function addInstitutionUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.post(apiRoute.addLoanInstition, payload);
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addPostGradInstitution(payload) {
  loanStore.loading();
  try {
    const { data } = await http.post(
      apiRoute.post_graduate_institution,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function editInstitution(payload) {
  loanStore.loading();
  try {
    const { data } = await http.post(apiRoute.edit_institution, payload);
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addLoanDetailsUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/others`, payload);
    toast.success(data.message);
    loanStore.loading();
    loanStore.setCurrentStepUnder("next-of-kin");
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addPostGradLoanDetails(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/postgradute/others`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    loanStore.setCurrentStepUnder("next-of-kin");
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function editLoanDetails(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/edit/others`, payload);
    toast.success(data.message);
    loanStore.loading();
    loanStore.setCurrentStepUnder("next-of-kin");
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}

export async function addLoanGuarantorOne(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/guarantor_one`, payload);
    toast.success(data.message);

    return data;
  } catch (err) {
    console.log(err);
    if (err instanceof AxiosError) {
      toast.error(
        err.response.data?.error ??
          "An error occurred could not add first guarantor details",
      );
    } else {
      toast.error(
        err.message ??
          "An error occurred could not add first guarantor details",
      );
    }
  } finally {
    loanStore.loading();
  }
}
export async function addPostGuarantorOne(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/guarantor_one`, payload);
    toast.success(data.message);
    loanStore.loading();

    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function editGuarantorOne(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/edit/guarantor_one`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();

    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addLoanGuarantorTwo(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/guarantor_two`, payload);
    toast.success(data.message);

    return data;
  } catch (err) {
    if (err instanceof AxiosError) {
      toast.error(
        err.response.data?.error ??
          "An error occurred could not add second guarantor details",
      );
    } else {
      toast.error(
        err.message ??
          "An error occurred could not add second guarantor details",
      );
    }
  } finally {
    loanStore.loading();
  }
}
export async function addPostLoanGuarantorTwo(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/guarantor_two`, payload);
    toast.success(data.message);
    loanStore.loading();

    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function editGuarantorTwo(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/edit/guarantor_two`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();

    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error &&
        toast.error(err.response.data.message || "Sorry could not connect");
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function saveEdit(id) {
  loanStore.loading();
  try {
    const { data } = await http.post(`${BASE_URL}/loans/edit/`, { id });
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}

export async function addNextOfKinUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(apiRoute.addNextOfKin, payload);
    toast.success(data.message);
    loanStore.loading();
    loanStore.setCurrentStepUnder("guarantor");
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}

export async function addGuarantorUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/undergraduate/guarantor`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    loanStore.setCurrentStepUnder("file-upload");
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}

export async function addFilesPostGrads(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/document/postgrads`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function editFiles(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/edit/document`, payload);
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addFilesUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/document`, payload);
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function uploadFile(payload) {
  try {
    const { data } = await http.put(`${BASE_URL}/loans/uploads`, payload);

    if (data.error) {
      throw new Error(
        data.message || "Unable to upload file please try again later"
      );
    }

    return data.data.upload_url;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message ||
        err?.message ||
        "Unable to upload file please try again later"
    );
  }
}
export async function addPostGradFilesUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/document/postgrads`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function editFilesUnder(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(`${BASE_URL}/loans/edit/document`, payload);
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addFilesUnderReapply(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/document/reapply`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addPostGradFilesUnderReapply(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/document/postgrads/reapply`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addFilesPostReapply(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/document/postgrads/reapply`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}
export async function addFilesGuarantor(payload) {
  loanStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/document/guarantor`,
      payload,
    );
    toast.success(data.message);
    loanStore.loading();
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.loading();
      toast.error("Network Error");
    }
  }
}

export async function verifyPayment(payload) {
  loanStore.togglePaymentLoading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/verify_app_payment`,
      payload,
    );
    toast.success(data.message);
    loanStore.togglePaymentLoading();
    loanStore.setCurrentStepUnder("verify-bvn");
    return data;
  } catch (err) {
    console.log(err);
    if (err && err.response) {
      loanStore.togglePaymentLoading();
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      loanStore.togglePaymentLoading();
      toast.error("Network Error");
    }
  }
}
export async function verifyRepayment(payload) {
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/verify-repayment`,
      payload,
    );
    return {
      status: "success",
      ...data,
    };
  } catch (err) {
    return {
      status: "failed",
      message: "An error occurred could not verify repayment",
      ...err?.response?.data,
    };
  }
}
export async function getCurrentLoanStage(payload) {
  try {
    const data = await http.put(apiRoute.currentLoanProgressStage, payload);
    return data;
  } catch (err) {
    if (err && err.response) {
      loanStore.loading();
      return err?.response?.data?.error;
    } else {
      toast.error(err);
    }
  } finally {
    loanStore.loading();
  }
}
export async function deleteLoan(id) {
  try {
    const { data } = await http.delete(`${BASE_URL}/loans/${id}`);
    return {
      data,
      err: null,
      status: "success",
    };
  } catch (err) {
    console.log(err);
    return {
      data: null,
      status: "failed",
      err,
      error_message: err.message,
    };
  }
}
export async function getLoanProfile() {
  try {
    const { data } = await http.get(`${BASE_URL}/loans/profile`);
    return {
      data,
      err: null,
      status: "success",
    };
  } catch (err) {
    console.log(err);
    return {
      data: null,
      status: "failed",
      err,
      error_message: err.message,
    };
  }
}
export async function updateLoanProfile(payload) {
  try {
    const { data } = await http.patch(`${BASE_URL}/loans/profile`,payload);
    return {
      data,
      err: null,
      status: "success",
    };
  } catch (err) {
    console.log(err);
    return {
      data: null,
      status: "failed",
      err,
      error_message: err.message,
    };
  }
}
export async function reapplyForLoan(payload) {
  try {
    const { data } = await http.post(`${BASE_URL}/loans/re-application`,payload);
    return {
      data,
      err: null,
      status: "success",
    };
  } catch (err) {
    console.log(err);
    return {
      data: null,
      status: "failed",
      err,
      error_message: err.message,
    };
  }
}
export async function handleReapplication(payload) {
  try {
    const { data } = await http.post(`${BASE_URL}/loans/re-application`,payload);
    return {
      data,
      err: null,
      status: "success",
    };
  } catch (err) {
    console.log(err);
    return {
      data: null,
      status: "failed",
      err,
      error_message: err.message,
    };
  }
}
export async function deleteLoans(selectedLoans) {
  try {
    const { data } = await http.post(`${BASE_URL}/loans/deleted`, {
      selectedLoans,
    });
    return {
      data,
      err: null,
      status: "success",
    };
  } catch (err) {
    console.log(err);
    return {
      data: null,
      status: "failed",
      err,
      error_message: err.message,
    };
  }
}
// export async function deleteLoans(loans) {
// 	try {
// 		const { data } = await http.delete(`${BASE_URL}/${id}`)
// 		return [data,null]
// 	} catch (err) {
// 		return [null,err]
// 	}
// }
